import { graphql } from '@/gql';

export const DeleteSubgroupMutation = graphql(`
    mutation DeleteSubgroup($id: ObjectID!) {
        deleteSubgroup(id: $id) {
            __typename
            ... on DeleteSubgroupSuccessfulResponse {
                success
                deletedId
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);
